module.exports = __webpack_public_path__ + "img/transaction_detail_dark.cf0e0072.svg";